import { Theme } from '@mui/material/styles';

export const labelStyles = (isDragging: boolean) => (theme: Theme) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: `0.125rem dashed ${isDragging ? theme.palette.primary.main : theme.palette.divider}`,
  padding: '1rem',
  borderRadius: '0.5rem',
  backgroundColor: isDragging ? theme.palette.background.paper : theme.palette.background.default,
  cursor: 'pointer',
  transition: 'background-color 0.3s, border-color 0.3s',
  width: '100%',
});

export const iconStyles = (isDragging: boolean) => (theme: Theme) => ({
  fontSize: '2rem',
  marginRight: '0.5rem',
  color: isDragging ? theme.palette.primary.main : theme.palette.text.secondary,
});

export const fileListStyles = (theme: Theme) => ({
  marginTop: '1.5rem',
  padding: '0.75rem',
  backgroundColor: theme.palette.background.default,
});

export const fileItemStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};

export const extraFilesStyles = (theme: Theme) => ({
  wordBreak: 'break-all',
  marginTop: '0.5rem',
  color: theme.palette.text.disabled,
});

export const errorStyles = (theme: Theme) => ({
  marginTop: '0.5rem',
  color: theme.palette.error.main,
});
